// Порт ref SubBlockSettingsEditor:734-826 (case 'table'): подсказка про авторазмер
// текста + счётчики «Строки: N/5» и «Столбцы: N/4». Выравнивание и стиль таблицы реф
// не предлагает — они зафиксированы дизайн-системой. `tableTextSize` в схеме есть, но
// канвас считает размер по числу столбцов и это поле не читает: контрол, который ничего
// не меняет, был бы фейковым аффордансом, поэтому его тут нет.
import type { DesignTable } from '@/types/blocks'
import { DESIGN_LIMITS, tableRows } from '@/features/editor/lib/designElements'
import {
  addTableColumn,
  addTableRow,
  removeTableColumn,
  removeTableRow,
  tableColumnCount,
} from '@/features/editor/lib/designTable'
import { CounterRow } from './CounterRow'
import { HintBox } from './HintBox'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  element: DesignTable
  onUpdate: (patch: Partial<DesignTable>) => void
}

export const TableSettings = ({ element, onUpdate }: Props) => {
  // Прямоугольность матрицы держит designTable — тут только проводка и границы.
  // Матрицы может не быть вовсе (битые данные бека): деградируем в нули, не в краш.
  const m = useMessages(messages)
  const data = tableRows(element.tableData)
  const rows = data.length
  const cols = tableColumnCount(data)

  // Границы дублируются в disabled и в самих обработчиках — ровно как в рефе:
  // гард дешевле бага, если кнопка придёт «включённой» из устаревшего рендера.
  const addRow = (): void => {
    if (rows >= DESIGN_LIMITS.TABLE_ROWS_MAX) return
    onUpdate({ tableData: addTableRow(data) })
  }

  const removeRow = (): void => {
    if (rows <= DESIGN_LIMITS.TABLE_ROWS_MIN) return
    onUpdate({ tableData: removeTableRow(data) })
  }

  const addColumn = (): void => {
    if (cols >= DESIGN_LIMITS.TABLE_COLS_MAX) return
    onUpdate({ tableData: addTableColumn(data) })
  }

  const removeColumn = (): void => {
    if (cols <= DESIGN_LIMITS.TABLE_COLS_MIN) return
    onUpdate({ tableData: removeTableColumn(data) })
  }

  return (
    // Реф держит подсказку в внешнем space-y-4, а счётчики — во вложенном space-y-3.
    <div className="space-y-4">
      <div className="space-y-3">
        <CounterRow
          label={m.rows}
          value={rows}
          min={DESIGN_LIMITS.TABLE_ROWS_MIN}
          max={DESIGN_LIMITS.TABLE_ROWS_MAX}
          addLabel={m.addRow}
          removeLabel={m.removeRow}
          onAdd={addRow}
          onRemove={removeRow}
        />
        <CounterRow
          label={m.columns}
          value={cols}
          min={DESIGN_LIMITS.TABLE_COLS_MIN}
          max={DESIGN_LIMITS.TABLE_COLS_MAX}
          addLabel={m.addColumn}
          removeLabel={m.removeColumn}
          onAdd={addColumn}
          onRemove={removeColumn}
        />
      </div>
      {/* Подсказка — плашкой под счётчиками, а не мелкой строкой над ними. */}
      <HintBox>{m.tableHint}</HintBox>
    </div>
  )
}
